








































import { CommentType } from "@/enums";
import storeHelper from "@/store/store-helper";
import { CommentReply } from "@/types/commentReply";
import Vue from "vue";
import CommentIcon from "./CommentIcon.vue";
import { Comment } from "@/documentComments";
import { PendingNewReply, PendingReplyEdit } from "@/types/document/pendingDocumentComments";

export default Vue.extend({
    name: "CommentReplyCard",
    props: {
        comment: Object as () => Comment,
        commentReplyId: Number,
        filledCommentReply: String,
        replyCommenterCommentType: String as () => CommentType,
        isReviewDocument: Boolean
    },
    components: { CommentIcon },
    data: function () {
        return {
            commentReply: this.filledCommentReply || ""
        };
    },
    created(): void {
        //add watchers only when we are reviewing
        if (this.isReviewDocument) {
            this.$watch("commentReply", newValue => {
                if (this.shouldEdit) storeHelper.pendingDocumentCommentStore.addUpdateReplyEdits(this.pendingReplyEdit);
                else storeHelper.pendingDocumentCommentStore.addUpdateNewReplies(this.pendingNewReply);
            });
        }
    },
    computed: {
        isReviewerComment(): boolean {
            return this.comment.type === CommentType.Reviewer;
        },
        isWriterComment(): boolean {
            return this.comment.type === CommentType.Writer;
        },
        shouldEdit() {
            return this.commentReplyId > 0;
        },
        smAndDown() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        pendingReplyEdit(): PendingReplyEdit {
            return {
                replyID: this.commentReplyId,
                replyText: this.commentReply,
                document: this.comment.document,
                commentID: this.comment.comment_id,
                isValid: this.validateForm()
            };
        },
        pendingNewReply(): PendingNewReply {
            return {
                replyText: this.commentReply,
                document: this.comment.document,
                commentID: this.comment.comment_id,
                isValid: this.validateForm(),
                commentType: this.replyCommenterCommentType
            };
        }
    },
    methods: {
        async onReply(commentId: number): Promise<void> {
            if (this.commentReply && this.validateForm()) {
                let commentReply = this.setupCommentReply(this.replyCommenterCommentType);
                if (this.shouldEdit) {
                    commentReply.comment_reply_id = this.commentReplyId;
                    const result = await storeHelper.documentStore.editCommentReplyAsync(commentId, commentReply);
                    if (this.isReviewDocument) {
                        storeHelper.pendingDocumentCommentStore.removeReplyEdits(this.commentReplyId);
                    }
                    if (!result.success) {
                        storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error"), true);
                    }
                } else {
                    const result = await storeHelper.documentStore.addCommentReplyAsync(commentId, commentReply);
                    if (!result.success) {
                        storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error"), true);
                    }
                    this.toggleOnReply();
                }
            }
        },
        setupCommentReply(commentType: CommentType): CommentReply {
            const commentReply: CommentReply = {
                comment_reply_id: 0,
                text: this.commentReply,
                created_by_user: null,
                comment_type: commentType,
                created_date_time: null,
                is_reject_reason: false
            };
            return commentReply;
        },

        required(): any {
            return (v: any) => !!v || `${this.$t("general.validation.isRequired")}`;
        },
        validateForm(): boolean {
            const formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

            return formIsValid;
        },
        toggleOnReply(): void {
            if (this.shouldEdit) {
                //since this component is only used in editmode we can assume that toggle means stop editing
                if (this.isReviewDocument) {
                    storeHelper.pendingDocumentCommentStore.removeReplyEdits(this.commentReplyId);
                }

                storeHelper.documentStore.toggleCommentReply(this.comment.comment_id, this.commentReplyId);
                return;
            }
            //since this component is only used in editmode we can assume that toggle means stop editing.
            //This function is called both after adding a reply and when the button to cancel edit is clicked.
            if (this.isReviewDocument) {
                storeHelper.pendingDocumentCommentStore.removeNewReplies(this.comment.comment_id);
            }
            this.$emit("toggle-on-reply");
        }
    }
});
